module.exports = __webpack_public_path__ + "img/sdc2022_9.06f0e48a.png";